export const allLinks = [
  {
    id: 1,
    title: 'Communicate with Customers',
    tag: 'communicate',
  },
  {
    id: 2,
    title: 'Run Your Day - to - Day',
    tag: 'run',
  },
  {
    id: 3,
    title: 'Manage & Track Finances',
    tag: 'manage',
  },
  {
    id: 4,
    title: 'Pay and Manage Your Team',
    tag: 'pay',
  },
  {
    id: 5,
    title: 'Build a Website',
    tag: 'build',
  },
  {
    id: 6,
    title: 'others relevant actions',
    tag: 'others',
  },
];
